import type { SceneDefinition } from "./Manufacturer";
import { ProductViewerLighting } from "./ProductViewerLighting";
import { SceneRenderer } from "./SceneRenderer";

export const PRODUCT_VIEWER_ENV_RESOLUTION = 512;

interface ProductViewerStageProps {
  /**
   * Optional manufacturer scene (e.g. grid floor). When omitted the standard
   * environment is used without any scene decoration.
   */
  scene?: SceneDefinition;
  resolution?: number;
}

/**
 * Single source of truth for product scene lighting + environment. Every canvas
 * (product viewer, mesh editor, preview/thumbnail capture) renders this so the
 * meshes are lit identically and the setups cannot drift apart.
 */
export const ProductViewerStage = ({
  scene,
  resolution = PRODUCT_VIEWER_ENV_RESOLUTION,
}: ProductViewerStageProps) => (
  <>
    <ProductViewerLighting />
    <SceneRenderer scene={scene} resolution={resolution} />
  </>
);
